import EmptyState from '../components/EmptyState';

export default function Publishing() {
  return (
    <EmptyState
      title="Publishing"
      description="Content release pipeline and shipped-tracking status"
    />
  );
}
